import PropTypes from "prop-types"

import SesIdentityShape from "./shapes/SesIdentityShape"
import { DomainStatusEnumKeys } from "./shapes/DomainStatusEnum"

const properties = {
  certificateRecordJson: PropTypes.string,
  certificatesDestroyedAt: PropTypes.string,
  cloudfrontDistributionsDestroyedAt: PropTypes.string,
  cognitoUsersDestroyedAt: PropTypes.string,
  configurationSetsDestroyedAt: PropTypes.string,
  controllerId: PropTypes.string,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.string,
  destroyedAt: PropTypes.string,
  disableReason: PropTypes.string,
  disabledAt: PropTypes.string,
  dnsRecordsDestroyedAt: PropTypes.string,
  docusignAccountId: PropTypes.string,
  docusignWebhookSecret: PropTypes.string,
  domain: PropTypes.string.isRequired,
  domainRecordJson: PropTypes.string,
  domainStatus: PropTypes.oneOf(DomainStatusEnumKeys).isRequired,
  dwollaCustomersDestroyedAt: PropTypes.string,
  email: PropTypes.string,
  emailFooterHtml: PropTypes.string,
  emailFooterSource: PropTypes.string,
  emailIdentity: SesIdentityShape,
  filesDestroyedAt: PropTypes.string,
  gatewayDestroyedAt: PropTypes.string,
  id: PropTypes.string.isRequired,
  identitiesDestroyedAt: PropTypes.string,
  isDestroyed: PropTypes.bool,
  isDisabled: PropTypes.bool.isRequired,
  isEmailVerified: PropTypes.bool,
  legalName: PropTypes.string,
  logoUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  parentOrganizationId: PropTypes.string,
  phoneNumber: PropTypes.string,
  pinpointProjectsDestroyedAt: PropTypes.string,
  tableRecordsDestroyedAt: PropTypes.string,
  updatedAt: PropTypes.string,
  updatedBy: PropTypes.string,
  userGroupIds: PropTypes.arrayOf(PropTypes.string)
}

const SetMyOrganizationControllerOutputShapeShape = PropTypes.exact(properties)

export default SetMyOrganizationControllerOutputShapeShape
export { properties }
